// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AlertController from "./alert_controller"
application.register("alert", AlertController)

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import AutocompleteController from "./autocomplete_controller"
application.register("autocomplete", AutocompleteController)

import BulkPdfDownloadController from "./bulk_pdf_download_controller"
application.register("bulk-pdf-download", BulkPdfDownloadController)

import BulkSelectController from "./bulk_select_controller"
application.register("bulk-select", BulkSelectController)

import BusinessNumberValidationController from "./business_number_validation_controller"
application.register("business-number-validation", BusinessNumberValidationController)

import CalendarController from "./calendar_controller"
application.register("calendar", CalendarController)

import ChartController from "./chart_controller"
application.register("chart", ChartController)

import CheckboxSelectController from "./checkbox_select_controller"
application.register("checkbox-select", CheckboxSelectController)

import ColumnFilterController from "./column_filter_controller"
application.register("column-filter", ColumnFilterController)

import ComboboxController from "./combobox_controller"
application.register("combobox", ComboboxController)

import CompanyFormController from "./company_form_controller"
application.register("company-form", CompanyFormController)

import CorrectiveActionTriggerController from "./corrective_action_trigger_controller"
application.register("corrective-action-trigger", CorrectiveActionTriggerController)

import DailyUsageController from "./daily_usage_controller"
application.register("daily-usage", DailyUsageController)

import DemoExitProgressController from "./demo_exit_progress_controller"
application.register("demo-exit-progress", DemoExitProgressController)

import DemoStartProgressController from "./demo_start_progress_controller"
application.register("demo-start-progress", DemoStartProgressController)

import DepartmentSelectorController from "./department_selector_controller"
application.register("department-selector", DepartmentSelectorController)

import DeviceManagementController from "./device_management_controller"
application.register("device-management", DeviceManagementController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import EmailValidationController from "./email_validation_controller"
application.register("email-validation", EmailValidationController)

import ExpandableController from "./expandable_controller"
application.register("expandable", ExpandableController)

import FileInputController from "./file_input_controller"
application.register("file-input", FileInputController)

import FmAccountController from "./fm_account_controller"
application.register("fm-account", FmAccountController)

import FmApprovalController from "./fm_approval_controller"
application.register("fm-approval", FmApprovalController)

import FormEmptyGuardController from "./form_empty_guard_controller"
application.register("form-empty-guard", FormEmptyGuardController)

import FormValidationController from "./form_validation_controller"
application.register("form-validation", FormValidationController)

import HandlingQuantityController from "./handling_quantity_controller"
application.register("handling-quantity", HandlingQuantityController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import ImagePreviewController from "./image_preview_controller"
application.register("image-preview", ImagePreviewController)

import ImageZoomController from "./image_zoom_controller"
application.register("image-zoom", ImageZoomController)

import ImprovementRequiredToggleController from "./improvement_required_toggle_controller"
application.register("improvement-required-toggle", ImprovementRequiredToggleController)

import IndustrySelectController from "./industry_select_controller"
application.register("industry-select", IndustrySelectController)

import InputFormatController from "./input_format_controller"
application.register("input-format", InputFormatController)

import InviteCodeController from "./invite_code_controller"
application.register("invite-code", InviteCodeController)

import ManagementControlRequiredController from "./management_control_required_controller"
application.register("management-control-required", ManagementControlRequiredController)

import MeasurementCalcController from "./measurement_calc_controller"
application.register("measurement-calc", MeasurementCalcController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import MsdsSearchSortController from "./msds_search_sort_controller"
application.register("msds-search-sort", MsdsSearchSortController)

import OrgChartController from "./org_chart_controller"
application.register("org-chart", OrgChartController)

import OrgChartDemoController from "./org_chart_demo_controller"
application.register("org-chart-demo", OrgChartDemoController)

import PasswordConfirmController from "./password_confirm_controller"
application.register("password-confirm", PasswordConfirmController)

import PasswordToggleController from "./password_toggle_controller"
application.register("password-toggle", PasswordToggleController)

import PasswordValidationController from "./password_validation_controller"
application.register("password-validation", PasswordValidationController)

import PdfDownloadController from "./pdf_download_controller"
application.register("pdf-download", PdfDownloadController)

import PdfPreviewerController from "./pdf_previewer_controller"
application.register("pdf-previewer", PdfPreviewerController)

import ParticipantsStashController from "./participants_stash_controller"
application.register("participants-stash", ParticipantsStashController)

import PhaseToggleController from "./phase_toggle_controller"
application.register("phase-toggle", PhaseToggleController)

import ProductUseController from "./product_use_controller"
application.register("product-use", ProductUseController)

import ReevalBannerController from "./reeval_banner_controller"
application.register("reeval-banner", ReevalBannerController)

import RegistrationFormController from "./registration_form_controller"
application.register("registration-form", RegistrationFormController)

import DismissableController from "./dismissable_controller"
application.register("dismissable", DismissableController)

import InlineCompareController from "./inline_compare_controller"
application.register("inline-compare", InlineCompareController)

import InlineDirectCompletedController from "./inline_direct_completed_controller"
application.register("inline-direct-completed", InlineDirectCompletedController)

import InlineCompleteController from "./inline_complete_controller"
application.register("inline-complete", InlineCompleteController)

import InlineEditController from "./inline_edit_controller"
application.register("inline-edit", InlineEditController)

import RowClickableController from "./row_clickable_controller"
application.register("row-clickable", RowClickableController)

import RowSelectController from "./row_select_controller"
application.register("row-select", RowSelectController)

import SearchInputController from "./search_input_controller"
application.register("search-input", SearchInputController)

import TableController from "./table_controller"
application.register("table", TableController)

import TermsAgreementController from "./terms_agreement_controller"
application.register("terms-agreement", TermsAgreementController)

import UsageClassifierController from "./usage_classifier_controller"
application.register("usage-classifier", UsageClassifierController)

import UsageInfoRequiredController from "./usage_info_required_controller"
application.register("usage-info-required", UsageInfoRequiredController)

import WorkerComplaintEditTriggerController from "./worker_complaint_edit_trigger_controller"
application.register("worker-complaint-edit-trigger", WorkerComplaintEditTriggerController)

import WorkerComplaintEditModeController from "./worker_complaint_edit_mode_controller"
application.register("worker-complaint-edit-mode", WorkerComplaintEditModeController)

import WorkerComplaintFormController from "./worker_complaint_form_controller"
application.register("worker-complaint-form", WorkerComplaintFormController)

import WorkerComplaintRequiredController from "./worker_complaint_required_controller"
application.register("worker-complaint-required", WorkerComplaintRequiredController)

import MsdsBatchUploadController from "./msds_batch_upload_controller"
application.register("msds-batch-upload", MsdsBatchUploadController)

import MsdsBatchProgressController from "./msds_batch_progress_controller"
application.register("msds-batch-progress", MsdsBatchProgressController)

import AdminTableFilterController from "./admin_table_filter_controller"
application.register("admin-table-filter", AdminTableFilterController)
